/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetWorkspacesIsCreatedResponse } from '../../models/get-workspaces-is-created-response';

export interface GetWorkspaceIsCreated$Params {

/**
 * Workspace ID
 */
  workspaceId: number;
}

export function getWorkspaceIsCreated(http: HttpClient, rootUrl: string, params: GetWorkspaceIsCreated$Params, context?: HttpContext): Observable<StrictHttpResponse<GetWorkspacesIsCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, getWorkspaceIsCreated.PATH, 'get');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetWorkspacesIsCreatedResponse>;
    })
  );
}

getWorkspaceIsCreated.PATH = '/workspaces/{workspaceId}/is-created';
